import { render, staticRenderFns } from "./AlternateHSQualifierUnder4List3.vue?vue&type=template&id=067175be&scoped=true&"
import script from "./AlternateHSQualifierUnder4List3.vue?vue&type=script&lang=ts&"
export * from "./AlternateHSQualifierUnder4List3.vue?vue&type=script&lang=ts&"
import style0 from "./AlternateHSQualifierUnder4List3.vue?vue&type=style&index=0&id=067175be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067175be",
  null
  
)

export default component.exports